require('./bootstrap');

import TomSelect from 'tom-select';
import { createApp } from 'vue'
import ProgressBarComponent from './components/ProgressBarComponent.vue'
import './lecturer_schedule_checkbox'
import './user_group_select'
import './document_before_open_confirm'
import './prefecture_select'
import './employee_contract'
import './lecturer_user_select'
import './career_consultant_assignment_select'
import './certification_application_index'
import './certification_application_edit'
import './document_preview'
import './office_staff_team_member_search'
import './branch_search'
import './user_dropout_confirm'
import './absence_evidence'
import './course_lecture_schedule_template_form'
import './course_lecture_schedule_drag'
import './course_lecture_schedule_form'
import './user_group_form_user_selection'
import './student-warning-modal'
import './make_up_lesson_remarks'
import './online_lesson_make_up_remarks'
import './online_lesson_bulk_certified_lecturer'
import './learning_history_toggle'
import './screening_results_notification_branch_select'
import './career_consultation_schedule_edit'
import './career_consultation_evaluation'
import './lecturer_schedule_decision_calendar_preview'
import './lecturer_schedule_decision_scroll_to_undecided'
import './lecturer_schedule_decision/index'
import './organization_logo'
import './organization_bank_account'
import './admin_sidebar_toggle'
import './student_course_show'
import './maintenance_countdown'
import './maintenance_schedule_popover'
import './maintenance_countdown_controls'
import './invoice_export_status'

window.TomSelect = TomSelect;
// Alpine は Livewire 3 が @livewireScripts で読み込んで起動する（ここでも起動すると二重になる）。
// Alpine.data() などの登録は document_preview.js のように alpine:init で行う

createApp({
    components:{
        ProgressBarComponent
    }
}).mount('#app')
